import { render } from "./AdminView.vue?vue&type=template&id=7fef1c71&ts=true"
import script from "./AdminView.vue?vue&type=script&lang=ts"
export * from "./AdminView.vue?vue&type=script&lang=ts"

import "./AdminView.vue?vue&type=style&index=0&id=7fef1c71&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__